import { M3Colors, SystemColors as SystemColorsBase  } from '../../base/config';
import { ThemeColorPalette, ThemeSystemColorPalette } from '../../colors.model';

export const SystemColors: ThemeSystemColorPalette = SystemColorsBase;

export const Colors: ThemeColorPalette = {
  // Default
  ...SystemColors,
  ...M3Colors,

  primary: {
    DEFAULT: '#cc071e',
    0: '#000000',
    10: '#410003',
    20: '#680009',
    25: '#7d000d',
    30: '#930011',
    35: '#a90015',
    40: '#c0001a',
    50: '#e6252d',
    60: '#ff544f',
    70: '#ff8981',
    80: '#ffb3ad',
    90: '#ffdad6',
    95: '#ffedeb',
    98: '#fff8f7',
    99: '#fffbff',
    100: '#ffffff',
  },
  secondary: {
    DEFAULT: '#2a2e38',
    0: '#000000',
    10: '#171c25',
    20: '#2c303a',
    25: '#373b46',
    30: '#434751',
    35: '#4e525d',
    40: '#5a5e69',
    50: '#737783',
    60: '#8d909d',
    70: '#a7abb7',
    80: '#c3c6d3',
    90: '#dfe2ef',
    95: '#edf0fe',
    98: '#f9f9ff',
    99: '#fefbff',
    100: '#ffffff',
  },
  tertiary: {
    DEFAULT: '#dbd9df',
    0: '#000000',
    10: '#1b1b20',
    20: '#303035',
    25: '#3b3b40',
    30: '#46464b',
    35: '#525257',
    40: '#5e5e63',
    50: '#77767c',
    60: '#919095',
    70: '#acaab0',
    80: '#c7c6cb',
    90: '#e4e1e7',
    95: '#f2f0f6',
    98: '#fbf8fe',
    99: '#fefbff',
    100: '#ffffff',
  },
  neutral: {
    DEFAULT: '#f3f2f7',
    0: '#000000',
    10: '#1c1b1b',
    20: '#313030',
    25: '#3c3b3b',
    30: '#484646',
    35: '#535252',
    40: '#5f5e5e',
    50: '#787676',
    60: '#929090',
    70: '#adaaaa',
    80: '#c9c6c5',
    90: '#e5e2e1',
    95: '#f4f0ef',
    98: '#fcf8f8',
    99: '#fdfbff',
    100: '#ffffff',
  },
  'neutral-variant': {
    DEFAULT: '#e8def8',
    0: '#000000',
    10: '#1e192b',
    20: '#332d41',
    25: '#3e384c',
    30: '#4a4458',
    35: '#554f64',
    40: '#625b70',
    50: '#7b748a',
    60: '#958da4',
    70: '#b0a7bf',
    80: '#cbc2db',
    90: '#e8def8',
    95: '#f6eeff',
    98: '#fdf7ff',
    99: '#fffbff',
    100: '#ffffff',
  },
  error: {
    DEFAULT: '#b00020',
    0: '#000000',
    10: '#b00020',
    20: '#bf152c',
    25: '#c61a2f',
    30: '#cc1d33',
    35: '#d91f34',
    40: '#de2839',
    50: '#ed323b',
    60: '#e84853',
    70: '#de6c74',
    80: '#ea959b',
    90: '#fbcad2',
    95: '#fdeaee',
    98: '#fef5f6',
    99: '#fffbff',
    100: '#ffffff',
  },
  accent: {
    DEFAULT: '#6750a4',
    0: '#000000',
    10: '#22005d',
    20: '#381e72',
    25: '#432b7e',
    30: '#4f378a',
    35: '#5b4397',
    40: '#6750a4',
    50: '#8069bf',
    60: '#9a83db',
    70: '#b69df7',
    80: '#cfbcff',
    90: '#e9ddff',
    95: '#f6eeff',
    98: '#fdf7ff',
    99: '#fffbff',
    100: '#ffffff',
  },
  success: {
    DEFAULT: '#28a746',
    0: '#000000',
    10: '#002106',
    20: '#003910',
    25: '#004615',
    30: '#00531a',
    35: '#006020',
    40: '#006e26',
    50: '#008a32',
    60: '#27a645',
    70: '#49c25d',
    80: '#66df76',
    90: '#83fc8f',
    95: '#c7ffc4',
    98: '#ebffe6',
    99: '#f6fff1',
    100: '#ffffff',
  },
  warning: {
    DEFAULT: '#ffc107',
    0: '#000000',
    10: '#261a00',
    20: '#3f2e00',
    25: '#4d3800',
    30: '#5b4300',
    35: '#6a4e00',
    40: '#785900',
    50: '#977100',
    60: '#b78a00',
    70: '#d8a300',
    80: '#fabd00',
    90: '#ffdf9e',
    95: '#ffefd4',
    98: '#fff8f2',
    99: '#fffbff',
    100: '#ffffff',
  },
  info: {
    DEFAULT: '#17a3b8',
  },
  surface: {
    DEFAULT: '#ece6f0',
  }
};
